// extracted by mini-css-extract-plugin
module.exports = {"price":"invoicerecapitulationitem_price__2NqYi","taxablePrice":"invoicerecapitulationitem_taxablePrice__3PeH_"};